import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/i42.png'
import _imports_1 from '@/assets/i43.png'
import _imports_2 from '@/assets/i35.png'
import _imports_3 from '@/assets/i44.png'
import _imports_4 from '@/assets/i45.png'
import _imports_5 from '@/assets/logo2.png'
import _imports_6 from '@/assets/i47.png'
import _imports_7 from '@/assets/i48.png'
import _imports_8 from '@/assets/i49.png'
import _imports_9 from '@/assets/i50.png'
import _imports_10 from '@/assets/i38.png'
import _imports_11 from '@/assets/i98.png'
import _imports_12 from '@/assets/i99.png'
import _imports_13 from '@/assets/quesheng.png'
import _imports_14 from '@/assets/i101.png'
import _imports_15 from '@/assets/i102.png'
import _imports_16 from '@/assets/i125.png'
import _imports_17 from '@/assets/i126.png'


const _withScopeId = n => (_pushScopeId("data-v-6e36a239"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "navBox" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "rightBox" }
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "btnBox" }
const _hoisted_7 = { class: "btn btn2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_1,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_9 = { class: "t" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wxCode" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img",
    src: _imports_2,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_13 = { class: "t" }
const _hoisted_14 = {
  key: 0,
  class: "dian"
}
const _hoisted_15 = { class: "userInfo" }
const _hoisted_16 = { class: "tbox" }
const _hoisted_17 = { class: "t" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_4,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_19 = { class: "moreInfo" }
const _hoisted_20 = { class: "box" }
const _hoisted_21 = { class: "ttop" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_5,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_23 = { class: "t" }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = { class: "itemBox" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_6,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_27 = { class: "t" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_7,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_29 = { class: "t" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_8,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_31 = { class: "t" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_9,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_33 = { class: "t" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "messageDrawer" }
const _hoisted_36 = { class: "titleMessage" }
const _hoisted_37 = { class: "t" }
const _hoisted_38 = { class: "n" }
const _hoisted_39 = {
  key: 0,
  class: "listBox"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "imgBox" }
const _hoisted_42 = {
  key: 0,
  class: "i",
  src: _imports_11,
  alt: "",
  srcset: ""
}
const _hoisted_43 = {
  key: 1,
  class: "i",
  src: _imports_12,
  alt: "",
  srcset: ""
}
const _hoisted_44 = { class: "name" }
const _hoisted_45 = { class: "msg" }
const _hoisted_46 = {
  key: 1,
  class: "noData"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_13,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_48 = { class: "t" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_14,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_50 = { class: "t" }
const _hoisted_51 = { class: "titleMessage" }
const _hoisted_52 = { class: "t" }
const _hoisted_53 = { class: "messageDrawerDetail" }
const _hoisted_54 = { class: "top" }
const _hoisted_55 = { class: "t" }
const _hoisted_56 = { class: "time" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_15,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_58 = { class: "tt" }
const _hoisted_59 = { class: "msgInfo" }
const _hoisted_60 = { class: "t" }
const _hoisted_61 = {
  key: 1,
  class: "loginContent"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_63 = { class: "box" }
const _hoisted_64 = { class: "inputBox" }
const _hoisted_65 = { class: "inputBoxT" }
const _hoisted_66 = { class: "input" }
const _hoisted_67 = { class: "lable" }
const _hoisted_68 = { class: "input" }
const _hoisted_69 = { class: "lable" }
const _hoisted_70 = { class: "input" }
const _hoisted_71 = { class: "lable" }
const _hoisted_72 = { class: "input" }
const _hoisted_73 = { class: "lable" }
const _hoisted_74 = { class: "input" }
const _hoisted_75 = { class: "lable" }
const _hoisted_76 = { class: "newInput" }
const _hoisted_77 = { class: "sBox" }
const _hoisted_78 = { class: "input" }
const _hoisted_79 = { class: "lable" }
const _hoisted_80 = { class: "newInput" }
const _hoisted_81 = { class: "pbox" }
const _hoisted_82 = { class: "yanma2" }
const _hoisted_83 = {
  key: 0,
  class: "inputBoxT"
}
const _hoisted_84 = {
  class: "input",
  style: {"align-items":"flex-start"}
}
const _hoisted_85 = { class: "lable" }
const _hoisted_86 = {
  class: "input",
  style: {"align-items":"flex-start","margin-bottom":".5rem"}
}
const _hoisted_87 = { class: "lable" }
const _hoisted_88 = { class: "uploadRef" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_16,
  alt: ""
}, null, -1))
const _hoisted_90 = { class: "t" }
const _hoisted_91 = { class: "fileList" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_17,
  alt: ""
}, null, -1))
const _hoisted_93 = { class: "t" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "fileMsg" }
const _hoisted_96 = { class: "PrivacyPolicy" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1rem"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { 'has-bg': _ctx.isBackgroundVisible }]),
    style: _normalizeStyle({position:_ctx.positionFixed?'fixed':'sticky'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onIndex()), ["stop"]))
      }),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexNavTop, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav", _ctx.navIdx == index?'active':'']),
            key: index,
            onClick: ($event: any) => (_ctx.onNav(item,index))
          }, _toDisplayString(item.title), 11, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchKey,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKey) = $event)),
            placeholder: _ctx.languageData?.H输入关键词,
            onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchResults()), ["enter"]))
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("img", {
            class: "i",
            src: _imports_0,
            alt: "",
            srcset: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchResults()))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.languageData?.H移动端查看数据), 1),
            _hoisted_10
          ]),
          _hoisted_11,
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getMessageDrawer && _ctx.getMessageDrawer(...args)))
          }, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.languageData?.H消息通知), 1),
            (_ctx.totalMsgNo > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.userInfo.company), 1),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.languageData?.H欢迎登录找磁材), 1)
              ]),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.userInfo.company), 1),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.companyPanel(1)))
                }, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.languageData?.H账号), 1)
                ]),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.companyPanel(2)))
                }, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.languageData?.H设备), 1)
                ]),
                _createElementVNode("div", {
                  class: "item",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.companyPanel(3)))
                }, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.languageData?.H管理), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "out",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loginOut()))
              }, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.languageData?.H退出), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.indexNavTop.length > 0 && _ctx.navShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["navBoxChild", { 'has-bg2': _ctx.isBackgroundVisible }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["item", _ctx.navChildIdx == null || _ctx.navChildIdx == 'null'?'active':'']),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onNavChild(null,{id:null})))
          }, _toDisplayString(_ctx.languageData?.H二级Home), 3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexNavTop[_ctx.navIdx]?.children, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", _ctx.navChildIdx == item.id?'active':'']),
              onClick: ($event: any) => (_ctx.onNavChild(index,item))
            }, _toDisplayString(item.title), 11, _hoisted_34))
          }), 256))
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_35, [
      _createVNode(_component_el_drawer, {
        class: "messageDrawer1",
        modelValue: _ctx.messageDrawer,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.messageDrawer) = $event)),
        "z-index": 9999999,
        size: "480",
        "show-close": false,
        "lock-scroll": false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.languageData?.H消息通知), 1),
            _createElementVNode("div", _hoisted_38, "（" + _toDisplayString(_ctx.totalMsgNo) + " " + _toDisplayString(_ctx.languageData?.H未读) + "）", 1),
            _createElementVNode("img", {
              class: "i",
              src: _imports_10,
              alt: "",
              srcset: "",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.messageDrawerClose()))
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_scrollbar, {
            height: "100%",
            ref: "listBoxMsg",
            onScroll: _ctx.handleScrollMsg,
            always: false
          }, {
            default: _withCtx(() => [
              (_ctx.msgListData.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.msgListData, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "list",
                        key: index,
                        onClick: ($event: any) => (_ctx.getmessageDrawerDetail(item))
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          (item.is_read == 1)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                            : (_openBlock(), _createElementBlock("img", _hoisted_43))
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["info", item.is_read == 1?'no':''])
                        }, [
                          _createElementVNode("div", _hoisted_44, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(item.content), 1)
                        ], 2)
                      ], 8, _hoisted_40))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.languageData?.H无消息), 1)
                  ]))
            ]),
            _: 1
          }, 8, ["onScroll"])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: "btnBox",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.msgAllRead && _ctx.msgAllRead(...args)))
          }, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.languageData?.H全部已读), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_drawer, {
        class: "messageDrawer1",
        modelValue: _ctx.messageDrawerDetail,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.messageDrawerDetail) = $event)),
        "z-index": 9999999,
        size: "480",
        modal: false,
        "show-close": false,
        "lock-scroll": false
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.languageData?.H消息通知), 1),
            _createElementVNode("img", {
              class: "i",
              src: _imports_10,
              alt: "",
              srcset: "",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onClosemessageDrawerDetail()))
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.msgListDataDetails.title), 1),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.msgListDataDetails.create_time), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", null, [
                _createElementVNode("pre", null, _toDisplayString(_ctx.msgListDataDetails.content), 1)
              ])
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", {
            class: "btnBox2",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onClosemessageDrawerDetail()))
          }, [
            _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.languageData?.H返回), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    (_ctx.showLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", {
            class: _normalizeClass(["contentT", [_ctx.loginIdx == 3?'contentT3':'',_ctx.formData.source == _ctx.languageData?.T02定制Ready按钮?'contentT4':'']])
          }, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("img", {
                class: "close",
                src: _imports_10,
                alt: "",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onshowLogin && _ctx.onshowLogin(...args)))
              }),
              (_ctx.loginIdx == 3)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["fromBox fromBox2", _ctx.formData.source == _ctx.languageData?.T02定制Ready按钮?'fromBox4':''])
                  }, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.languageData?.J加入CompanyName), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.company,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.company) = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.languageData?.J加入FullName), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.name,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.name) = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.languageData?.J加入JobTitle), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.position,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.position) = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.languageData?.J加入CompanyEmail), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.email,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.email) = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.languageData?.J加入SelectCountry), 1),
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_el_select_v2, {
                                "popper-class": "type-popper",
                                modelValue: _ctx.formData.country,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.country) = $event)),
                                options: _ctx.countryList,
                                "value-key": "en",
                                "popper-append-to-body": false,
                                props: {
													label: 'en',
													value: 'en',
												},
                                placeholder: ""
                              }, null, 8, ["modelValue", "options"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.languageData?.J加入PhoneNumber), 1),
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.countryList.find((item) => item.en == _ctx.formData.country)?.prefix), 1),
                              _createVNode(_component_el_input, {
                                class: "codeIpnut2",
                                modelValue: _ctx.formData.phone,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.phone) = $event)),
                                autocomplete: "off"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.formData.source == _ctx.languageData?.T02定制Ready按钮)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.languageData?.J加入Message), 1),
                              _createVNode(_component_el_input, {
                                class: "textareaT",
                                type: "textarea",
                                modelValue: _ctx.formData.message,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.message) = $event)),
                                autocomplete: "off"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.languageData?.J加入Attachments), 1),
                              _createVNode(_component_el_upload, {
                                ref: "uploadRef",
                                "file-list": _ctx.fileList,
                                "onUpdate:fileList": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.fileList) = $event)),
                                "show-file-list": false,
                                action: "/api/Ajax/upload",
                                "on-change": _ctx.onChange,
                                class: "upload-demo",
                                "auto-upload": true
                              }, {
                                trigger: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_88, [
                                    _hoisted_89,
                                    _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.languageData?.J加入SelectFile), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["file-list", "on-change"]),
                              _createElementVNode("div", _hoisted_91, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "list",
                                    key: index
                                  }, [
                                    _hoisted_92,
                                    _createElementVNode("div", _hoisted_93, _toDisplayString(item.name), 1),
                                    _createElementVNode("img", {
                                      class: "d",
                                      src: _imports_10,
                                      alt: "",
                                      onClick: _withModifiers(($event: any) => (_ctx.delFile(index)), ["stop"])
                                    }, null, 8, _hoisted_94)
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.languageData?.J文件上传提示), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _createTextVNode(_toDisplayString(_ctx.languageData?.J加入Msg), 1),
                      _createElementVNode("span", {
                        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onPrivacyPolicy && _ctx.onPrivacyPolicy(...args)))
                      }, _toDisplayString(_ctx.languageData?.J加入PrivacyPolicy), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "btnTT",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onContact()))
                    }, _toDisplayString(_ctx.languageData?.J加入Submit), 1),
                    _hoisted_97
                  ], 2))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 6))
}